import { LocationDescriptorObject } from 'history'
import { serializeSearchQuery } from '#src/services/search'

export default function yachtSearchLocationForLocation(
  charterLocation: string
): LocationDescriptorObject {
  const loc = serializeSearchQuery({
    categorySlug: 'charters',
    selections: {
      l: {
        name: 'attributes:charterLocation',
        alias: 'l',
        bucketValues: [charterLocation]
      }
    }
  })

  return {
    pathname: loc.pathname,
    search: loc.searchParams.toString()
  }
}
